import { render, staticRenderFns } from "./sw-widget-loading.vue?vue&type=template&id=3fa39e09&"
import script from "./sw-widget-loading.vue?vue&type=script&lang=tsx&"
export * from "./sw-widget-loading.vue?vue&type=script&lang=tsx&"
import style0 from "./sw-widget-loading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports